import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { NS, U2101ROLES } from "../../../U2101";
import { FaPlus, FaRegFile, FaTrashAlt } from "react-icons/fa";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";

interface U2101FormStateHandlers extends U2000FormStateHandlers<any> {
  getData: () => any;
  getFormState: () => U2000FormStateEnumState;
  addNewLogicalUnit: () => void;
  modifyLogicalUnit: () => void;
  deleteLogicalUnit: () => void;
}

interface U2101LogicalUnitFormBtnsComponentProps {
  formStateHandlers: U2101FormStateHandlers;
}

export const U2101LogicalUnitFormToolBar: React.FC<U2101LogicalUnitFormBtnsComponentProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();

  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: "add",
      label: t("btnAdd", { ns: NS }),
      hasRole: hasRole(U2101ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewLogicalUnit();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U2101ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyLogicalUnit();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: "delete",
      label: t("btnDelete", { ns: NS }),
      hasRole: hasRole(U2101ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteLogicalUnit();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
